import { Component, Input } from '@angular/core';

import { CustomEventService } from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-gitwiser-notification-modal',
  templateUrl: './gitwiser-notification-modal.component.html'
})
export class GitwiserNotificationModalComponent {

  @Input() analysisId: string;

  constructor(
    private customEventService: CustomEventService
  ) { }

  closeModal(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  cancelAnalysis(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CANCEL_ANALYSIS, this.analysisId);
  }
}
